module.exports = __webpack_public_path__ + "media/images/dashboard/platinum-61015856a8778b7abfef5d57272cb989.svg";